import { ColumnDef } from "@tanstack/react-table";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import { DataTableColumnHeader } from "./data-table-column-header";
import { INcm } from "@/@types/ncm";
import { Badge } from "@/components/ui/badge";
import { DataTableRowActions } from "./data-table-row-actions";
import { ToggleStatusSwitch } from "./toggle-switch";

export const columns: ColumnDef<INcm>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
  },
  {
    accessorKey: "ncm",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="NCM" />
    ),
    cell: ({ row }) => row.original.ncm,
  },
  {
    accessorKey: "state",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="UF" />
    ),
    cell: ({ row }) => row.original.state,
  },
  {
    accessorKey: "iva",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="IVA" />
    ),
    cell: ({ row }) => `${row.original.iva.replace(".", ",")}%`,
  },
  {
    accessorKey: "internal_tax_rate",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Interno" />
    ),
    cell: ({ row }) => `${row.original.internal_tax_rate.replace(".", ",")}%`,
  },
  {
    accessorKey: "interstate_tax",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Interestadual" />
    ),
    cell: ({ row }) => `${row.original.interstate_tax.replace(".", ",")}%`,
  },
  {
    accessorKey: "is_active",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => {
      const isActive = row.original.is_active;

      return (
        <Badge
          className={`cursor-default transition-colors ${isActive
            ? "bg-green-500 text-white hover:bg-green-600"
            : "bg-red-500 text-white hover:bg-red-600"
            }`}
        >
          {isActive ? "Ativo" : "Inativo"}
        </Badge>
      );
    },
  },

  {
    accessorKey: "created_at",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Criado Em" />
    ),
    cell: ({ row }) => {
      const dateString = row.getValue("created_at") as string;
      if (!dateString) return "";

      try {
        const parsedDate = parseISO(dateString);
        return format(parsedDate, "dd/MM/yyyy HH:mm:ss", { locale: ptBR });
      } catch (error) {
        return "Data Inválida";
      }
    },
  },
  {
    accessorKey: "updated_at",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Atualizado Em" />
    ),
    cell: ({ row }) => {
      const dateString = row.getValue("updated_at") as string;
      if (!dateString) return "";

      try {
        const parsedDate = parseISO(dateString);
        return format(parsedDate, "dd/MM/yyyy HH:mm:ss", { locale: ptBR });
      } catch (error) {
        return "Data Inválida";
      }
    },
  },
  {
    id: "toggle",
    header: "Alterar Status",
    cell: ({ row }) => (
      <div className="flex items-center justify-center">
        <ToggleStatusSwitch
          id={row.original.id}
          isActive={row.original.is_active}
        />
      </div>
    ),
  },
  {
    id: "actions",
    header: "Ações",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
];
